import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// ─── Existing app pages (unchanged) ──────────────────────────────────────────
import Home from './pages/Home';
import TulySearch from './pages/TulySearch';
import TulyFlow from './pages/TulyFlow';
import Login from './pages/Login';
import Categories from './pages/Categories';
import CategoryTools from './pages/CategoryTools';
import SearchHistoryList from './pages/SearchHistoryList';
import ToolDetails from './pages/ToolDetails';
import SuggestTool from './pages/SuggestTool';
import Signup from './pages/Signup';
import Activation from './pages/Activation';
import ResetPassword from './pages/ResetPassword';
import Workflow from './pages/Workflow';
import AIExecutionDashboard from './pages/AIExecutionDashboard';
import SharedWorkflow from './pages/SharedWorkflow';
import SharedGitexWorkflow from './pages/SharedGitexWorkflow';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GoldenLine from './pages/GoldenLine';
import GitexBoothExperience from './pages/GitexBoothExperience';

// ─── New marketing / landing pages ───────────────────────────────────────────
import Landing from './pages/Landing';
import Solutions from './pages/Solutions';
import BoQSolution from './pages/BoQSolution';
import SubmittalsSolution from './pages/SubmittalsSolution';
import Platform from './pages/Platform';
import Industries from './pages/Industries';
import SMESolutions from './pages/SMESolutions';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminLeads from './pages/AdminLeads';
import AdminChats from './pages/AdminChats';
import AdminClients from './pages/AdminClients';

import { AuthProvider } from './utils/AuthContext';

const ProtectedRoute = ({ children }) => {
  const token = Cookies.get('authToken');
  return token ? children : <Navigate to="/landing" />;
};

const AdminRoute = ({ children }) => {
  const token = sessionStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* ── Protected App Routes ── */}
        <Route path="/catgs"    element={<ProtectedRoute><Categories /></ProtectedRoute>} />
        <Route path="/catgtools" element={<CategoryTools />} />
        <Route path="/ex_report" element={<ProtectedRoute><AIExecutionDashboard /></ProtectedRoute>} />
        <Route path="/login"    element={<Login />} />
        <Route path="/home"     element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/suggest"  element={<ProtectedRoute><SuggestTool /></ProtectedRoute>} />
        <Route path="/"         element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/tuly"     element={<ProtectedRoute><TulyFlow /></ProtectedRoute>} />
        <Route path="/finder"   element={<ProtectedRoute><TulySearch /></ProtectedRoute>} />
        <Route path="/workflow" element={<ProtectedRoute><Workflow /></ProtectedRoute>} />
        <Route path="/history"  element={<ProtectedRoute><SearchHistoryList /></ProtectedRoute>} />
        <Route path="/tool"     element={<ProtectedRoute><ToolDetails /></ProtectedRoute>} />
        <Route path="/signup"   element={<Signup />} />
        <Route path="/golden"   element={<ProtectedRoute><GoldenLine /></ProtectedRoute>} />
        <Route path="/activate/:token"          element={<Activation />} />
        <Route path="/sharedworkflow/:shareId"  element={<SharedWorkflow />} />
        <Route path="/gitexworkflow/:shareId"   element={<SharedGitexWorkflow />} />
        <Route path="/gitex"   element={<GitexBoothExperience />} />
        <Route path="/reset-password/:token"    element={<ResetPassword />} />
        <Route path="/terms"   element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* ── Public Marketing / Landing Routes ── */}
        <Route path="/landing"               element={<Landing />} />
        <Route path="/solutions"             element={<Solutions />} />
        <Route path="/solutions/boq"         element={<BoQSolution />} />
        <Route path="/solutions/submittals"  element={<SubmittalsSolution />} />
        <Route path="/platform"              element={<Platform />} />
        <Route path="/industries"            element={<Industries />} />
        <Route path="/industries/:slug"      element={<Industries />} />
        <Route path="/sme-solutions"         element={<SMESolutions />} />
        <Route path="/about"                 element={<About />} />
        <Route path="/contact"               element={<Contact />} />

        {/* ── Admin Routes ── */}
        <Route path="/admin/login"    element={<AdminLogin />} />
        <Route path="/admin/leads"    element={<AdminRoute><AdminLeads /></AdminRoute>} />
        <Route path="/admin/chats"    element={<AdminRoute><AdminChats /></AdminRoute>} />
        <Route path="/admin/clients"  element={<AdminRoute><AdminClients /></AdminRoute>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
